import React, { Suspense, useEffect } from 'react'
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { CSpinner, useColorModes } from '@coreui/react-pro'
// import { Toaster } from 'react-hot-toast'
import Toaster from 'src/components/Toaster/Toaster'
import 'src/scss/style.scss'

// We use those styles to show code examples, you should remove them in your application.
import { State } from 'src/store'

// Containers
const DefaultLayout = React.lazy(() => import('src/layout/DefaultLayout'))
const Login = React.lazy(() => import('src/views/Login/Login'))
const ForgotPassword = React.lazy(() => import('src/views/Login/ForgotPassword'))
const ResetPassword = React.lazy(() => import('src/views/Login/ResetPassword'))
const LockScreen = React.lazy(() => import('src/views/Login/LockScreen'))
// Email App

export function PrivateRoute({ children }) {
  const test = localStorage.getItem('token')
  if (test) {
    return children
  } else {
    return <Navigate to="/login" />
  }
}

const App = () => {
  const { isColorModeSet, setColorMode } = useColorModes(
    'coreui-pro-react-admin-template-theme-modern',
  )
  const storedTheme = useSelector((state: State) => state.theme)
  const toasters = useSelector((state: State) => state.toasters)

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.href.split('?')[1])
    let theme = urlParams.get('theme')

    if (theme !== null && theme.match(/^[A-Za-z0-9\s]+/)) {
      theme = theme.match(/^[A-Za-z0-9\s]+/)![0]
    }

    if (theme) {
      setColorMode(theme)
    }

    if (isColorModeSet()) {
      return
    }

    setColorMode(storedTheme)
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <BrowserRouter>
      <Suspense
        fallback={
          <div className="pt-3 text-center">
            <CSpinner color="primary" variant="grow" />
          </div>
        }
      >
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/lock" element={<LockScreen />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route
            path="*"
            element={
              <PrivateRoute>
                <DefaultLayout />
              </PrivateRoute>
            }
          />
        </Routes>
        {/* <Toaster
          position="top-right"
          toastOptions={{
            duration: 2000,
            className: '',
            style: {
              border: '1px solid #132a57',
              padding: '16px',
              color: '#132a57',
            },
          }}
        /> */}
        <Toaster notifications={toasters} />
      </Suspense>
    </BrowserRouter>
  )
}

export default App
